(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.shopify-section-header');
        this.headerOverlay = document.querySelector('.header-overlay');
        this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.preventReveal = false;

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
          this.header.classList.add('always-fixed');
          //if (this.headerOverlay) {
          //	this.headerOverlay.classList.add('color-background-1');
          //	this.headerOverlay.classList.remove('color-inverse');
          //}
        }

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop > this.headerBounds.top && this.headerIsAlwaysSticky) {
          this.headerOverlay?.classList.add('color-background-1');
          this.headerOverlay?.classList.remove('color-inverse');
        }
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (document.querySelector('.search-modal.active')) return;
        if (document.querySelector('.burger-drawer.active')) {
          this.header.classList.remove('shopify-section-header-hidden', 'animate');
        }
        if (document.querySelector('.burger-drawer.active')) return;
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        if (this.headerOverlay) {
          this.headerOverlay.classList.add('color-background-1');
        }
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
        if (this.headerOverlay) {
          this.headerOverlay.classList.add('color-background-1');
          this.headerOverlay.classList.remove('color-inverse');
        }
      }

      reset() {
        if (this.headerIsAlwaysSticky) {
          if (this.headerOverlay) {
            this.headerOverlay.classList.remove('color-background-1');
            this.headerOverlay.classList.add('color-inverse');
          }
          return;
        }

        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
        if (this.headerOverlay) {
          this.headerOverlay.classList.remove('color-background-1');
          this.headerOverlay.classList.add('color-inverse');
        }
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
        if (this.disclosures) {
          this.disclosures.forEach((disclosure) => {
            disclosure.close();
          });
        }
        this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
        if (this.disclosureLists) {
          this.disclosureLists.forEach((disclosureList) => {
            disclosureList.setAttribute('hidden', true);
          });
        }
        this.disclosureButton = this.header.querySelectorAll('.disclosure__button');
        if (this.disclosureButton) {
          this.disclosureButton.forEach((disclosureButton) => {
            disclosureButton.setAttribute('aria-expanded', false);
          });
        }
      }
    }

    customElements.define('sticky-header', StickyHeader);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'input',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const modal = document.querySelector('.product-media-modal__content');

    modal.addEventListener('click', (e) => {
      const media = e.target.closest('img');

      if (!media) return;

      const zoomInContainer = media.nextElementSibling;

      if (!zoomInContainer) return;

      zoomInContainer.classList.add('zoom-in--active');
      const imgcontainer = zoomInContainer.querySelector('img');

      if (!imgcontainer) return;

      zoomInContainer.addEventListener('mousemove', (e) => {
        if (window.innerWidth <= 750) return;
        const rect = imgcontainer.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        const zoom = 1.5;
        const offsetX = (x - 0.5) * 100;
        const offsetY = (y - 0.5) * 100;
        imgcontainer.style.transform = `scale(${zoom})`;
        imgcontainer.style.transformOrigin = `${x}% ${y}%`;
      });

      zoomInContainer.addEventListener('click', (e) => {
        zoomInContainer.classList.remove('zoom-in--active');
      });
    });
  });

  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      if (activeMedia) {
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
      }

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              // Re-initialise colour swatches for the freshly injected cards so
              // selecting a swatch updates the card image and sets the correct
              // variant on the Add to Cart form.
              if (typeof colorSwatches === 'function') colorSwatches();
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px',
      }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
